import { createContext, PropsWithChildren, useMemo } from "react";

import { EvaluationCreateFormValue } from "./EvaluationCreateFormContext.decl";

export const EvaluationCreateFormContext =
  createContext<EvaluationCreateFormValue | null>(null);

export function EvaluationCreateFormProvider({
  children,
  form,
  ratingScales,
}: PropsWithChildren<EvaluationCreateFormValue>) {
  const value = useMemo<EvaluationCreateFormValue>(
    () => ({
      ratingScales,
      form,
    }),
    [form, ratingScales]
  );

  return (
    <EvaluationCreateFormContext.Provider value={value}>
      {children}
    </EvaluationCreateFormContext.Provider>
  );
}
